import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { SzamlazzHuIcon } from '@components/ui/svgIcons'
import { Tooltip } from '@components/ui/Tooltips'

import { PARTNER_SOURCES } from '@constants'

import { BillingoIcon, ManualSourceIcon, TmsSourceIcon } from './SvgIcons'

const IconWrapper = styled.div`
  & > svg {
    transform: translate(0, 2px);
  }
`

type PartnerSourceVariant = Nullable<(typeof PARTNER_SOURCES)[keyof typeof PARTNER_SOURCES]>

function getTooltipContent(variant: PartnerSourceVariant) {
  switch (variant) {
    case PARTNER_SOURCES.SOURCE_SZAMLAZZ:
      return {
        title: (
          <FormattedMessage
            id="partnerSource.tooltips.szlahu"
            defaultMessage="Ezt a partnert a Számlázz.hu rendszeréből szinkronizáltuk"
          />
        ),
        icon: <SzamlazzHuIcon />,
      }

    case PARTNER_SOURCES.SOURCE_BILLINGO:
      return {
        title: (
          <FormattedMessage
            id="partnerSource.tooltips.billingo"
            defaultMessage="Ezt a partnert a Billingo rendszeréből szinkronizáltuk"
          />
        ),
        icon: <BillingoIcon />,
      }

    case PARTNER_SOURCES.SOURCE_QUICK:
      return {
        title: (
          <FormattedMessage
            id="partnerSource.tooltips.quickAutoGenerated"
            defaultMessage="Ezt a partnert a Keret- és adófigyelő automatikusan hozta létre"
          />
        ),
        icon: <TmsSourceIcon />,
      }

    default:
      return {
        title: <FormattedMessage id="partnerSource.tooltips.manual" defaultMessage="Kézzel rögzített partner" />,
        icon: <ManualSourceIcon />,
      }
  }
}

export function PartnerSource({ variant }: { variant: PartnerSourceVariant }) {
  const { title, icon } = getTooltipContent(variant)

  return (
    <Tooltip title={title}>
      <IconWrapper>{icon}</IconWrapper>
    </Tooltip>
  )
}
